module.exports = __webpack_public_path__ + "static/media/icon-manage-class-group.f1f53d58.svg";